module.exports = __webpack_public_path__ + "static/newsletter-9d2c0ff57923f86daf9c144d526c993b.jpg";